import P from 'prop-types';
import { useEffect } from 'react';

export const Modal = ({ data, children }) => {
  const handleClickClose = () => {
    data.isModalOpen(false);
  };

  useEffect(() => data.isModalOpen(true), []);

  return (
    <div
      className="modal fade"
      id={data.ref}
      data-bs-keyboard="false"
      data-bs-backdrop="static"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {data.title}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClickClose}
            ></button>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Fechar
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  data: P.shape({
    ref: P.string,
    title: P.string,
    isModalOpen: P.func,
  }),
  children: P.node,
};
